export const GET_STATISTIC = 'GET_STATISTIC';
export const GET_STATISTIC_OK = 'GET_STATISTIC_OK';
export const GET_STATISTIC_FAIL = 'GET_STATISTIC_FAIL';

import getSchoolStatisticCrtl from 'controllers/school/getSchoolStatistic';

export function fetchSchoolStatistic(schoolId) {
  return function(dispatch){
    dispatch({
      type: GET_STATISTIC,
    })
    getSchoolStatisticCrtl(schoolId)
      .then(result=>{
        dispatch({
          type: GET_STATISTIC_OK,
          payload: result
        })
      })
      .catch(err=>{
        dispatch({
          type: GET_STATISTIC_FAIL,
          payload: err
        })
      })
  }
}
const initialState = {
  fetching: false,
  statistic: {}
}
export default function schoolStatistic (state = initialState, action){
  switch(action.type) {
    case GET_STATISTIC: 
      return { ...state, fetching: true}
    case GET_STATISTIC_OK: 
      return { ...state, statistic: action.payload, fetching: false}
    case GET_STATISTIC_FAIL: 
      return { ...state, err: action.payload, fetching: false}
    default: 
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/containers/pages/Dashboard/ducks.js